import { j as p } from "../../../node_modules/react/jsx-runtime.js";
import { memo as a } from "react";
import { clsx as c } from "../../../node_modules/clsx/dist/clsx.m.js";
import e from "./Skeleton.module.scss.js";
const u = ({
  variant: s = "rectangle",
  color: t = "white",
  height: n,
  width: r,
  animation: o = "pulse",
  style: l,
  ...m
}) => {
  const i = c(e.root, e[s], e[t], {
    [e.pulseAnimation]: o === "pulse",
    [e.waveAnimation]: o === "wave",
    [e.noAnimation]: o === "none"
  });
  return /* @__PURE__ */ p.jsx(
    "div",
    {
      className: i,
      style: { ...l, height: n, width: r },
      ...m
    }
  );
}, v = a(u);
export {
  v as default
};
//# sourceMappingURL=Skeleton.js.map
